import { useTranslation } from 'react-i18next';

const BRAND_PREFIX_MAP: Record<string, string> = {
  WHIRL: 'W',
  MYTAG: 'M',
  KHAID: 'K',
  AMANA: 'A',
  JNAIR: 'J',
  GLADI: 'G',
};

export const useModelSerialExamples = (brand?: string) => {
  const { t } = useTranslation('modelSerialLanding');

  const b = (brand || '').trim().toUpperCase();
  const prefix = BRAND_PREFIX_MAP[b] ?? 'W';
  const modelExample = `${prefix}ABC1234YZ`;
  const serialExample = 'E61201983';

  return {
    modelExample,
    serialExample,
    modelHintText: t('modelNumber.hint', { example: modelExample }),
    serialHintText: t('serialNumber.hint', { example: serialExample }),
  };
};
